import React from 'react'
import './commonHeading.css'

function INCSUBCommonHeading({ text = "" }) {
    return (
        <div className="INCSUBHeader_ctn_about_content_hold_heading">
            {text}
            {/* <svg width="131" height="106" viewBox="0 0 131 106" fill="none" xmlns="http://www.w3.org/2000/svg" >
                { <rect x="91" y="84" width="22" height="22" rx="11" fill="#2BB775" />
                <rect x="117" y="22" width="14" height="14" rx="7" fill="#8B61DF" />
                <rect width="36" height="36" rx="18" fill="#E09710" /> }
            </svg> */}
        </div>
    )
}

export default INCSUBCommonHeading;